import { useTranslation } from "react-i18next";
import {
	type CourseLesson,
	getLessonDaysCount,
} from "src/components/Course/lessons/Lesson/RepetitionLesson";
import Progress from "src/components/ExamComponents/Progress";
import DefaultDetails, {
	DefaultScore,
} from "src/components/NewComponents/Views/Details/DefaultDetails";

interface ProgressDetailsProps {
	total: number;
}

const ProgressDetails = ({ total }: ProgressDetailsProps) => {
	const { t } = useTranslation();
	return (
		<Progress allItems={total} resolvedItems={0} unit={t("units.lessons")} />
	);
};

interface BlockedRepetitionDetailsProps {
	lesson: CourseLesson;
	className?: string;
}

export const BlockedRepetitionDetails = ({
	lesson,
	className,
}: BlockedRepetitionDetailsProps) => {
	const { t } = useTranslation();
	return (
		<DefaultDetails
			className={className}
			title={lesson.name}
			Score={() => (
				<div className="flex gap-8">
					<DefaultScore
						className="purple-box"
						title={t("course.lessons.revision")}
					/>
				</div>
			)}
			Progress={() => (
				<>
					<ProgressDetails total={getLessonDaysCount(lesson)} />
					<p className="size-12 text-grey m-0">
						{t("course.lessons.blockedRevisionHint")}
					</p>
				</>
			)}
		/>
	);
};
